"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classes = require("../classes");
var _api = require("../api");
var Auth = /*#__PURE__*/function () {
  function Auth() {
    (0, _classCallCheck2["default"])(this, Auth);
  }
  (0, _createClass2["default"])(Auth, null, [{
    key: "login",
    value: function login(usrId, usrName, pwd) {
      var shopId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var chainId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return new _promise["default"](function (resolve, reject) {
        if (!chainId) _api.LogwebAPI.login(usrId, usrName, pwd, shopId, function (json) {
          _api.NextApiClient.userAuthData = {
            id: usrId,
            name: usrName,
            pwd: pwd
          };
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          reject(err);
        });else _api.LogwebAPI.loginChain(usrId, usrName, pwd, shopId, chainId, function (json) {
          _api.NextApiClient.userAuthData = {
            id: usrId,
            name: usrName,
            pwd: pwd
          };
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "loginCustomID",
    value: function loginCustomID(usrId, pwd) {
      var shopId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var chainId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return new _promise["default"](function (resolve, reject) {
        _api.LogwebAPI.loginCustomID(usrId, pwd, shopId, function (json) {
          _api.NextApiClient.userAuthCustomID = {
            id: usrId,
            pwd: pwd
          };
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "guestLogin",
    value: function guestLogin() {
      var chainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new _promise["default"](function (resolve, reject) {
        if (!chainId) _api.LogwebAPI.guestLogin(103, function (json) {
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          reject(err);
        });else _api.LogwebAPI.guestLoginChain(103, chainId, function (json) {
          _api.NextApiClient.currentChain = chainId;
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "customerLogin",
    value: function customerLogin(user, pwd) {
      var chainId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new _promise["default"](function (resolve, reject) {
        _api.LogguestAPI.guestLogin(user, pwd, chainId, function (guestUid) {
          _api.NextApiClient.setGuestUID(guestUid);
          resolve(guestUid);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "customerSingin",
    value: function customerSingin(user, pwd) {
      return new _promise["default"](function (resolve, reject) {
        _api.GuestbookAPI.guestLogin(user, pwd, function (res) {
          _api.NextApiClient.setGuestUID(res.GUID);
          resolve(res);
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "customerRegister",
    value: function customerRegister(guestData, pwd, pwdConfirm, code) {
      return new _promise["default"](function (resolve, reject) {
        _api.GuestbookAPI.registerGuest(guestData, pwd, pwdConfirm, code, function (res) {
          _api.NextApiClient.setGuestUID(res.GUID);
          resolve(res);
        }, reject);
      });
    }
  }, {
    key: "adalLogin",
    value: function adalLogin(user, oid, chainId) {
      return new _promise["default"](function (resolve, reject) {
        if (!Auth.isADAL()) {
          reject();
        }
        _api.NextApiClient.com('LogWeb', !!chainId ? 'jADALoginChain' : 'jADALogin', {
          UPN: user,
          azureoid: oid,
          chainid: chainId || undefined
        }, function (json) {
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          resolve(err);
        });
      });
    }
  }, {
    key: "rsaLogin",
    value: function rsaLogin(chainId) {
      return new _promise["default"](function (resolve, reject) {
        if (!Auth.isRSA()) {
          reject(new Error('RSA key is not defined'));
        }
        _api.NextApiClient.com('LogWeb', 'RSALoginUserChain', {
          compressed: _api.NextApiClient.rsaKey,
          chainid: chainId || ''
        }, function (json) {
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, function (err) {
          resolve(err);
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      return new _promise["default"](function (resolve, reject) {
        _api.QueryAPI.sessionEnd(function (res) {
          var event = new Event('3cad:logout');
          window.dispatchEvent(event);
          resolve(res);
        }, reject);
      });
    }
  }, {
    key: "setShop",
    value: function setShop(cod) {
      return new _promise["default"](function (resolve, reject) {
        _api.LogwebAPI.chooseShop(cod, function (json) {
          if (json.shop && json.shop.cod) Auth.saveShop(json.shop.cod);
          resolve(new _classes.Profile(json));
        }, reject);
      });
    }
  }, {
    key: "saveShop",
    value: function saveShop(shopCod) {
      _api.NextApiClient.userAuthShop = shopCod;
    }
  }, {
    key: "isRSA",
    value: function isRSA() {
      return !!_api.NextApiClient.rsaKey;
    }
  }, {
    key: "isADAL",
    value: function isADAL() {
      return !!_api.NextApiClient.adalAuthData;
    }
  }]);
  return Auth;
}();
exports.Auth = Auth;
//# sourceMappingURL=Auth.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/Auth.js
// module id = 1240
// module chunks = 142